import axios from 'axios';
import type { Integration } from '@/models/integration';
class IntegrationWebservice {
    public async getMicrosoft() {
        const res = await axios.get<Integration>('/integrations/microsoft');
        return res.data;
    }

    public async authorizeLink(integration: Integration) {
        const baseUrl = process.env.VUE_APP_BACKEND_BASE_URL;
        const res = await axios.get<string>(
            `${integration.controller_relative_link}/authorize/${integration.id}/link`,
            {
                baseURL: baseUrl,
            }
        );
        return res.data;
    }

    public async revoke(integration: Integration) {
        const baseUrl = process.env.VUE_APP_BACKEND_BASE_URL;
        const res = await axios.post<boolean>(
            `${integration.controller_relative_link}/revoke`,
            {},
            {
                baseURL: baseUrl,
            }
        );
        return res.data;
    }
}

export const integrationWebservice = new IntegrationWebservice();
